import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { Observable, throwError, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IBrandProfile } from '../interfaces/brand-profile';
import { IBillerDivision } from '../interfaces/biller-division';

const ENV_REGION = 'env-region';
const BASE_URL = 'base-url';
const BRAND_CODE = 'brand-code';
const BRAND_PROFILE = 'brand-profile';
const EXT_ACCT_ID = 'ext-acct-id';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  protected walletronRegions = environment.walletronRegions;
  protected disbursementsBasePath = environment.disbursementsBasePath;  
  protected walletronBasePath = environment.walletronBasePath;  
  protected authServerBaseUrl = environment.authServerBasePath;  
  protected portalServerBaseUrl = environment.portalServerBasePath;  

  constructor() { }

  // Clear all application items from the local storage
  public clearUserSession() {
    localStorage.clear();
  }

  // Getter and setter for enviromental region
  public setEnvRegion(envRegion: string){
    localStorage.removeItem(ENV_REGION);
    localStorage.setItem(ENV_REGION, envRegion);
  }
  
  public getEnvRegion(): any | null{
    return localStorage.getItem(ENV_REGION);    
//    return 'qa';
  }

  // Getter and setter for region's base URL
  public setBaseUrl(baseUrl: string){
    localStorage.removeItem(BASE_URL);
    localStorage.setItem(BASE_URL, baseUrl);
  }
  
  public getBaseUrl(): any | null{
    return localStorage.getItem(BASE_URL);    
  }

  // Getter and setter for brand code
  public setBrandCode(brandCode: string){
    localStorage.removeItem(BRAND_CODE);
    localStorage.setItem(BRAND_CODE, brandCode);
  }
  
  public getBrandCode(): any | null{
    return localStorage.getItem(BRAND_CODE);    
  }

  // Getter and setter for brand profile  
  public setBrandProfile(brandProfile: IBrandProfile){
    localStorage.removeItem(BRAND_PROFILE);
    localStorage.setItem(BRAND_PROFILE, JSON.stringify(brandProfile));
    console.log('brandProfile - set', brandProfile);
  }
  
  public getBrandProfile(): IBrandProfile{
    let brandProfile = localStorage.getItem(BRAND_PROFILE);
    console.log('brandProfile - get', brandProfile);
    if (brandProfile) {
      return JSON.parse(brandProfile);    
    }
    else {
      const bp: IBrandProfile = {brandCode: '', brandName: '', billerId: '', divisions: []};
      return bp;
    }
    // return this.brandProfile;
  }  

  // Getter and setter for customer account number
  public setAccountNum(accountNum: string){
    console.log('setAccountNum', accountNum);
    localStorage.removeItem(EXT_ACCT_ID);
    localStorage.setItem(EXT_ACCT_ID, accountNum);
  }
  
  public getAccountNum(): any | null{
    console.log('getAccountNum', localStorage.getItem(EXT_ACCT_ID));
    return localStorage.getItem(EXT_ACCT_ID);    
  }


  // Get the base URL of Walletron Portal
  public getPortalBaseUrl(): string {
    return this.portalServerBaseUrl;
  }

  // Get the base URL of Auth Server
  public getAuthServerBaseUrl(): string {
    return this.authServerBaseUrl;
  }

  // Find out the base url for the given region
  public getDisbursementsBaseUrl(envRegion: string): string {
    var regionConfig = this.walletronRegions.find(item => item.region === envRegion.toLowerCase());
    if (regionConfig) {
      return regionConfig.baseUrl + this.disbursementsBasePath;
    } else {
      return '';
    }
  }

  public getBrandStyleScheme (brandProfile: IBrandProfile): any {
    let brandStyleTheme = {};
    let configProperties = brandProfile.configProperties;
    for (const propName in configProperties) {
      if (propName == 'DSB_BRAND_STYLE_SCHEME') {
        brandStyleTheme = JSON.parse(configProperties[propName]);
      }
    }
    return brandStyleTheme;    
  }

  public getCustomizedPrompt(promptCode: string): string | undefined {
    return this.getConfigProperty('DSB_CUSTOM_PROMPTS', promptCode);
  }

  public getCustomizedTitle(titleCode: string): string | undefined {
    return this.getConfigProperty('DSB_CUSTOM_TITLES', titleCode);
  }


  public getDisbursementReasons(): any[] {
    let dsbReasons: any[] = [];
    let brandProfile = this.getBrandProfile();
    let configProperties = brandProfile.configProperties;
    for (const propName in configProperties) {
      if (propName == 'DSB_PAYMENT_REASONS') {
        dsbReasons = JSON.parse(configProperties[propName]);
      }
    }
    return dsbReasons;
  }

  private getConfigProperty(propertyName: string, variantCode: string): string | undefined{
    let brandProfile = this.getBrandProfile();
    if (brandProfile) {
      let configProperties = brandProfile.configProperties;
      for (const propName in configProperties) {
        if (propName == propertyName) {
          let jsonObject = JSON.parse(configProperties[propName]);
          if (!jsonObject) {
            return '';
          }
          let map = new Map<string, string>();
          for (var value in jsonObject) {
            map.set(value, jsonObject[value]);
          }
          if (map.has(variantCode)) {
            return map.get(variantCode);
          }
        }
      }
    }
    return '';
  }

  public getBillerDivisions(): IBillerDivision[] | undefined {
    let brandProfile = this.getBrandProfile();
    if (brandProfile) {
      return brandProfile.divisions;
    } 
    return;
  }

  // Format given date field as yyyy-mm-dd
  public getFormattedDate(d: any) {
    if (d instanceof Date) {
      var day = String(d.getDate()).padStart(2, '0');
      var month = String(d.getMonth() + 1).padStart(2, '0'); //Months are zero based
      var year = d.getFullYear();
      return year + "-" + month + "-" + day;
    } else {
      return d;
    }
  }

  public formatFromEpoch(dt: string): string {
    let date = new Date(dt);
    const format = 'yyyy-MM-dd';
    const locale = 'en-US';
    const formattedDate = formatDate(date, format, locale);
    return formattedDate;
  }

  // Common error handling routines
  // public handleError(error: HttpErrorResponse) {

  //   if (error.status === 0) {
  //     // A client-side or network error occurred. Handle it accordingly.
  //     console.error('An error occurred:', error.error);
  //   } else {
  //     // The backend returned an unsuccessful response code.
  //     // The response body may contain clues as to what went wrong.
  //     console.error(
  //       `Backend returned code ${error.status}, body was: `, error.error);
  //   }
  //   // Return an observable with a user-facing error message.
  //   return throwError(() => new Error('Something bad happened; please try again later.'));
  // } 

  public handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
      console.log(`${error.status} failed: ${error.error.message}`);
    } else {
      // server-side error
      errorMessage = `Error: ${error.error.message}`;
      console.log(`${error.status} failed: ${error.error.message}`);
    }
    return throwError(() => {
        return errorMessage;
    });
  } 

  public handleError2<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.

      const str: string = error.message as unknown as string;
      let result = {} as T;

      return of(result);
    };
  }    





}
